const { DEFAULT_RUNSTYLE } = require('../../Shape/AbstractShape/config/defaultStyles');
const { sameRunStyleInTextBodies } = require('../utils');

exports.computeFontWeightFromTextBodies = (textBodies, textSelection) => sameRunStyleInTextBodies(
    textBodies,
    'font.weight',
    DEFAULT_RUNSTYLE.font.weight,
    { skipUndefined: false, textSelection }
);
